import React from "react";
import { Button, Empty, Table2 } from "components";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import config from "constants/config";
import { ArrowRightIcon } from "../../../icons";
import { random } from "../../comms/appeal";
import useMobile from "../../../../../hooks/useMobile";
import MobileProducts from "./mobile-products";
import MobilePlaceholder from "../../products/upselling/mobile-placeholder";
import { MoreInfo } from "../../../layouts/dashboard/sidebar/icons/icons/icons";
import { Tooltip } from "@paylixecommerce/shared/components";
import { CSVLink } from "react-csv";
import { CSVIcon } from "../../../../../components/icons";


import "./style.scss";


export const CartIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M5.00001 17.4993C5.92048 17.4993 6.66668 16.7532 6.66668 15.8327C6.66668 14.9122 5.92048 14.166 5.00001 14.166C4.07954 14.166 3.33334 14.9122 3.33334 15.8327C3.33334 16.7532 4.07954 17.4993 5.00001 17.4993Z" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M14.1667 17.4993C15.0871 17.4993 15.8333 16.7532 15.8333 15.8327C15.8333 14.9122 15.0871 14.166 14.1667 14.166C13.2462 14.166 12.5 14.9122 12.5 15.8327C12.5 16.7532 13.2462 17.4993 14.1667 17.4993Z" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M14.1667 14.1667H5.00001V2.5H3.33334" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M5 4.16602L16.6667 4.99935L15.8333 10.8327H5" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

export const SubsIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M18 9.54849C17.7707 7.8987 17.0054 6.37005 15.8218 5.19802C14.6383 4.02599 13.1023 3.2756 11.4503 3.06245C9.79836 2.84929 8.12215 3.18519 6.67988 4.01841C5.23761 4.85163 4.1093 6.13593 3.46875 7.67349M3 4.92349V7.67349H5.75" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M3 11.4238C3.22927 13.0736 3.99462 14.6023 5.17815 15.7743C6.36168 16.9463 7.89773 17.6967 9.54968 17.9099C11.2016 18.123 12.8779 17.7871 14.3201 16.9539C15.7624 16.1207 16.8907 14.8364 17.5312 13.2988M18 16.0488V13.2988H15.25" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M12.3833 8.75001C12.2777 8.5667 12.1241 8.41559 11.9392 8.31283C11.7542 8.21008 11.5448 8.15956 11.3333 8.16668H10.1667C9.85725 8.16668 9.5605 8.28959 9.34171 8.50839C9.12292 8.72718 9 9.02392 9 9.33334C9 9.64276 9.12292 9.93951 9.34171 10.1583C9.5605 10.3771 9.85725 10.5 10.1667 10.5H11.3333C11.6428 10.5 11.9395 10.6229 12.1583 10.8417C12.3771 11.0605 12.5 11.3573 12.5 11.6667C12.5 11.9761 12.3771 12.2728 12.1583 12.4916C11.9395 12.7104 11.6428 12.8333 11.3333 12.8333H10.1667C9.9552 12.8405 9.74578 12.7899 9.56083 12.6872C9.37587 12.5844 9.22234 12.4333 9.11667 12.25" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M10.75 12.8333V14M10.75 7V8.16667V7Z" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

export const ProductIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M11.6666 2.5V5.83333C11.6666 6.05435 11.7544 6.26631 11.9107 6.42259C12.067 6.57887 12.2789 6.66667 12.5 6.66667H15.8333" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M14.1666 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V4.16667C4.16663 3.72464 4.34222 3.30072 4.65478 2.98816C4.96734 2.67559 5.39127 2.5 5.83329 2.5H11.6666L15.8333 6.66667V15.8333C15.8333 16.2754 15.6577 16.6993 15.3451 17.0118C15.0326 17.3244 14.6087 17.5 14.1666 17.5Z" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M7.5 5.83398H8.33333" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M7.5 10.834H12.5" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M10.8334 14.166H12.5" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

export const STATUSES_ICONS = {
	PENDING: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25Z" stroke="#E16727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7 4.0835V7.00016L8.75 8.75016" stroke="#E16727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	COMPLETED: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25Z" stroke="#239F51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5.25 7.00016L6.41667 8.16683L8.75 5.8335" stroke="#239F51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	VOIDED: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25Z" stroke="#D24242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5.8335 5.8335L8.16683 8.16683M8.16683 5.8335L5.8335 8.16683" stroke="#D24242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	WAITING_FOR_CONFIRMATIONS: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M3.7915 4.0835H10.2082" stroke="#E16727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M3.5 11.6667V10.5C3.5 9.57174 3.86875 8.6815 4.52513 8.02513C5.1815 7.36875 6.07174 7 7 7C7.92826 7 8.8185 7.36875 9.47487 8.02513C10.1313 8.6815 10.5 9.57174 10.5 10.5V11.6667C10.5 11.8214 10.4385 11.9697 10.3291 12.0791C10.2197 12.1885 10.0714 12.25 9.91667 12.25H4.08333C3.92862 12.25 3.78025 12.1885 3.67085 12.0791C3.56146 11.9697 3.5 11.8214 3.5 11.6667Z" stroke="#E16727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M3.5 2.33333V3.5C3.5 4.42826 3.86875 5.3185 4.52513 5.97487C5.1815 6.63125 6.07174 7 7 7C7.92826 7 8.8185 6.63125 9.47487 5.97487C10.1313 5.3185 10.5 4.42826 10.5 3.5V2.33333C10.5 2.17862 10.4385 2.03025 10.3291 1.92085C10.2197 1.81146 10.0714 1.75 9.91667 1.75H4.08333C3.92862 1.75 3.78025 1.81146 3.67085 1.92085C3.56146 2.03025 3.5 2.17862 3.5 2.33333Z" stroke="#E16727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	WAITING_SHOP_ACTION: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.75 12.25H12.25" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M1.75 3.85V4.375C1.75 4.79272 1.93437 5.19332 2.26256 5.48869C2.59075 5.78406 3.03587 5.95 3.5 5.95C3.96413 5.95 4.40925 5.78406 4.73744 5.48869C5.06563 5.19332 5.25 4.79272 5.25 4.375V3.85M5.25 4.375C5.25 4.79272 5.43437 5.19332 5.76256 5.48869C6.09075 5.78406 6.53587 5.95 7 5.95C7.46413 5.95 7.90925 5.78406 8.23744 5.48869C8.56563 5.19332 8.75 4.79272 8.75 4.375V3.85M8.75 4.375C8.75 4.79272 8.93437 5.19332 9.26256 5.48869C9.59075 5.78406 10.0359 5.95 10.5 5.95C10.9641 5.95 11.4092 5.78406 11.7374 5.48869C12.0656 5.19332 12.25 4.79272 12.25 4.375V3.85H1.75L2.91667 1.75H11.0833L12.25 3.85" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M2.9165 12.2499V6.3291" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M11.0835 12.2499V6.3291" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5.25 12.25V9.91667C5.25 9.60725 5.37292 9.3105 5.59171 9.09171C5.8105 8.87292 6.10725 8.75 6.41667 8.75H7.58333C7.89275 8.75 8.1895 8.87292 8.40829 9.09171C8.62708 9.3105 8.75 9.60725 8.75 9.91667V12.25" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	PARTIAL: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.75 7C1.75 7.68944 1.8858 8.37213 2.14963 9.00909C2.41347 9.64605 2.80018 10.2248 3.28769 10.7123C3.7752 11.1998 4.35395 11.5865 4.99091 11.8504C5.62787 12.1142 6.31056 12.25 7 12.25C7.68944 12.25 8.37213 12.1142 9.00909 11.8504C9.64605 11.5865 10.2248 11.1998 10.7123 10.7123C11.1998 10.2248 11.5865 9.64605 11.8504 9.00909C12.1142 8.37213 12.25 7.68944 12.25 7C12.25 6.31056 12.1142 5.62787 11.8504 4.99091C11.5865 4.35395 11.1998 3.7752 10.7123 3.28769C10.2248 2.80018 9.64605 2.41347 9.00909 2.14963C8.37213 1.8858 7.68944 1.75 7 1.75C6.31056 1.75 5.62787 1.8858 4.99091 2.14963C4.35395 2.41347 3.7752 2.80018 3.28769 3.28769C2.80018 3.7752 2.41347 4.35395 2.14963 4.99091C1.8858 5.62787 1.75 6.31056 1.75 7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7 9.91683C7.77355 9.91683 8.51541 9.60954 9.06239 9.06256C9.60938 8.51558 9.91667 7.77371 9.91667 7.00016C9.91667 6.22661 9.60938 5.48475 9.06239 4.93777C8.51541 4.39079 7.77355 4.0835 7 4.0835V9.91683Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	REVERSED: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.2001 4.5501C11.2001 3.197 10.1815 2.1001 8.9251 2.1001H4.3751C3.11865 2.1001 2.1001 3.197 2.1001 4.5501V9.4501C2.1001 10.8032 3.11865 11.9001 4.3751 11.9001H8.9251C10.1815 11.9001 11.2001 10.8032 11.2001 9.4501V7.7001" stroke="var(--pink6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M11.2002 8.50769V7M11.2002 7L9.4502 8.72308M11.2002 7L12.9502 8.72308" stroke="var(--pink6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7.96843 5.77501C7.89446 5.64669 7.78699 5.54091 7.65752 5.46898C7.52805 5.39705 7.38146 5.36169 7.23343 5.36667H6.41676C6.20017 5.36667 5.99245 5.45272 5.83929 5.60587C5.68614 5.75902 5.6001 5.96675 5.6001 6.18334C5.6001 6.39993 5.68614 6.60766 5.83929 6.76081C5.99245 6.91397 6.20017 7.00001 6.41676 7.00001H7.23343C7.45002 7.00001 7.65775 7.08605 7.8109 7.2392C7.96406 7.39236 8.0501 7.60008 8.0501 7.81667C8.0501 8.03327 7.96406 8.24099 7.8109 8.39414C7.65775 8.5473 7.45002 8.63334 7.23343 8.63334H6.41676C6.26874 8.63832 6.12215 8.60296 5.99268 8.53103C5.86321 8.4591 5.75573 8.35332 5.68176 8.22501" stroke="var(--pink6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M6.8252 8.63314V9.4498M6.8252 4.5498V5.36647V4.5498Z" stroke="var(--pink6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	REFUNDED: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2.1001 12.6001V3.26676C2.1001 2.95735 2.2476 2.6606 2.51015 2.44181C2.7727 2.22301 3.12879 2.1001 3.5001 2.1001H10.5001C10.8714 2.1001 11.2275 2.22301 11.49 2.44181C11.7526 2.6606 11.9001 2.95735 11.9001 3.26676V12.6001L9.8001 11.4334L8.4001 12.6001L7.0001 11.4334L5.6001 12.6001L4.2001 11.4334L2.1001 12.6001Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M8.75 8.3999V7.23324C8.75 6.92382 8.62708 6.62707 8.40829 6.40828C8.1895 6.18949 7.89275 6.06657 7.58333 6.06657H5.25L6.41667 4.8999M6.41667 7.23324L5.25 6.06657" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	CUSTOMER_DISPUTE_ONGOING: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12.2535 10.4962L9.46289 7.70557" stroke="#E16727" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M9.46265 7.70554L7.46694 9.70125C7.02721 10.141 6.31124 10.141 5.87151 9.70125L3.48117 7.31091C3.04143 6.87118 3.04143 6.1552 3.48117 5.71547L7.46694 1.7297C7.90668 1.28997 8.62265 1.28997 9.06238 1.7297L11.4527 4.12005C11.8924 4.55978 11.8924 5.27575 11.4527 5.71547L9.46265 7.70554Z" stroke="#E16727" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M2.1001 11.8999H5.48265" stroke="#E16727" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M4.6709 4.52588L8.65669 8.51163" stroke="#E16727" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	PROCESSING: <svg style={{ minWidth: 14 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12.6001 6.68404C12.4396 5.52919 11.9039 4.45913 11.0754 3.63871C10.2469 2.81829 9.17169 2.29302 8.01532 2.14381C6.85895 1.9946 5.6856 2.22973 4.67601 2.81298C3.66642 3.39624 2.8766 4.29525 2.42822 5.37154M2.1001 3.44654V5.37154H4.0251" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M2.1001 7.99658C2.26059 9.15144 2.79633 10.2215 3.6248 11.0419C4.45327 11.8623 5.52851 12.3876 6.68488 12.5368C7.84124 12.686 9.0146 12.4509 10.0242 11.8676C11.0338 11.2844 11.8236 10.3854 12.272 9.30908M12.6001 11.2341V9.30908H10.6751" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5.6001 7.3501H9.1001" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7.3501 5.6001L9.1001 7.3501L7.3501 9.1001" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}


const InvoicesTable = ({ isAdmin, placeholderData, clearFilters, isEmpty, orders, loading, skipCSV }) => {

	const isMobile = useMobile();
	const history = useHistory();
	const renderStatus = ({ row }) => {
		const status = config.ORDER_STATUS[row.original.status] || "";

		return (
			<div className="d-flex justify-content-center gap-2">
				{row.original.status === "VOIDED" && row.original.void_details === "PRODUCT_SOLD_OUT" && <span className="badge badge-cancelled">Product Sold Out</span>}
				{row.original.status === "VOIDED" && row.original.void_details === "CART_PRODUCTS_SOLD_OUT" && <span className="badge badge-cancelled">Cart Products Sold Out</span>}
				{row.original.status === "COMPLETED" && row.original.status_details === "CART_PARTIAL_OUT_OF_STOCK" && <span className="badge badge-cancelled">Cart Partial Out Of Stock</span>}
				<div className={`badge badge-${status.toLowerCase()}`}>{STATUSES_ICONS[row.original.status]}&nbsp;{row.original.status === "WAITING_SHOP_ACTION" ? "Shop Action" : status}</div>

				{row.original.is_evm_approved ?
					<Tooltip name={`approved-${row.original.uniqid}`} tooltipText={`The customer has approved Paylix to use the allowance of their ${row.original.gateway} funds to automatically pay for recurring invoices.`}>
						<div className={`badge badge-confirmation`}>
							Allowance
						</div>
					</Tooltip>
					// You have allowed us to automatically use your {CRYPTO} funds to pay for invoices on recurring bills.
					: null}
			</div>
		)
	};

	const renderValue = ({ row }) => {

		let isFree = +row.original.total_display === 0;

		if(isFree) {
			return <div className="d-flex flex-column text-nowrap">
				<span className="d-flex" />
				<span className="d-flex" style={{ fontWeight: 400, fontSize: 12, lineHeight: "15px", color: "var(--black4)" }}>Free</span>
			</div>
		}

		return <div className="d-flex flex-column text-nowrap">
			<div className="d-flex align-items-center mb-1">{config.CURRENCY_LIST[row.original.currency]}{row.original.total_display} <div style={{ marginLeft: ".35rem", fontWeight: 400, fontSize: 13, lineHeight: "15px", color: "var(--black5)" }} >(qt {row.original.quantity})</div></div>
			<div style={{ fontWeight: 400, fontSize: 13, lineHeight: "15px", color: "var(--black4)" }} className="d-flex">{row.original.crypto_amount}</div>
		</div>
	};

	const renderGateway = ({ row }) => {

		let isFree = +row.original.total_display === 0;

		if(isFree || !row.original.gateway) {
			return "-"
		}

		return <div className="d-flex align-items-center">
			<img className="mr-2" style={{ width: 15, height: 15 }} src={config.PAYMENT_ICONS[row.original.gateway]} alt=""/> {config.PAYMENT_FULL_NAME[row.original.gateway]}
		</div>
	};

	const renderTime = ({ row }) => moment(row.original.created_at * 1000).format('HH:mm DD MMM')

	const flag = (country) => {
		if(country && country.length > 1) {
			return `${config.CDN_FLAGS_URL}${(country || "").toLowerCase()}.svg`
		} else {
			return null
		}
	};

	const MoreInfo = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="var(--black4)" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M8 5.33325H8.00667" stroke="var(--black4)" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7.3335 8H8.00016V10.6667H8.66683" stroke="var(--black4)" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>

	const renderInfo = ({ row }) => (

			<div className="d-flex">

				<div className="invoice-list-icon">
					{row.original.type === 'SHOPPING_CART' ?
						<CartIcon /> :
						row.original.type === 'PRODUCT_SUBSCRIPTION' ?
							<SubsIcon /> :
							<ProductIcon />
					}
				</div>
				<div>
					<span className="d-flex mb-1">
						{row.original.uniqid ? <Link to={`/invoices/${row.original.uniqid}`} target="_blank">
							{row.original.customer_email ? row.original.customer_email : row.original.type === "SUBSCRIPTION" ? "Subscription" : ""}
						</Link> : row.original.customer_email ? row.original.customer_email : ""}
						{row.original.country && row.original.country !== 'N/A' ? <img src={flag(row.original.country)} className="flag-icon ml-2" alt={row.location} style={{ width: 19, height: 14, borderRadius: 2 }} /> : null}
					</span>
						<span className="invoice-list-id">
							{row.original.uniqid}
							<span className="ml-1">
								<Tooltip tooltipText={row.original.type === 'SHOPPING_CART' ? "Shopping cart purchase" : `${row.original.product_title ? row.original.product_title : "No Product Provided"}`} name={row.original.uniqid}>
									<MoreInfo />
								</Tooltip>
							</span>
					</span>
				</div>
				<a href={`/invoices/${row.original.uniqid}`} target="_blank" id={`a-blank-fix-${row.original.uniqid}`} />
			</div>
	)

	const columns = [{
		accessor: 'uniqid',
		Header: 'Info',
		Cell: renderInfo
	}, {
		accessor: 'gateway',
		Header: 'Gateway',
		Cell: renderGateway
	}, {
		accessor: 'total_display',
		Header: 'Value',
		Cell: renderValue,
		sortType: (a, b) => {
			if(parseInt(b.original.total_display) > parseInt(a.original.total_display)) {
				return 1
			}
			if(parseInt(a.original.total_display) > parseInt(b.original.total_display)) {
				return -1
			}
			return 0
		}
	}, {
		accessor: 'status',
		Header: 'Status',
		Cell: renderStatus
	}, {
		accessor: 'created_at',
		Header: 'Time',
		Cell: renderTime
	}, {
		accessor: 'id',
		disableSortBy: true,
		Header: () => {
			return isAdmin || skipCSV ? null :
				<div className="d-flex justify-content-end">
					<span>
						<Tooltip tooltipText="Export CSV" name="export-csv" >
							<CSVLink filename="paylixecommerce-invoices" data={orders || []}>
								<Button variant="secondary" size="small" square>
									<CSVIcon />
								</Button>
							</CSVLink>
						</Tooltip>
					</span>
				</div>
		},
		Cell: () => <div className="d-flex align-items-center justify-content-end">
			<ArrowRightIcon />
		</div>
	}];

	const placeholder = [{
		accessor: 'uniqid',
		Header: 'Info',
		Cell: () => (
			<Link to="/" className="d-flex">
				<div className="invoice-list-icon">
					<ProductIcon />
				</div>
				<div>
					<span className="d-flex mb-1"><div className="mb-2 skeleton skeleton2 small" style={{ width: random(150, 250)}} /></span>
					<span className="invoice-list-id"><div className="skeleton skeleton7 small" style={{ width: random(120)}} /></span>
				</div>
			</Link>
		)
	}, {
		accessor: 'gateway',
		Header: 'Gateway',
		Cell: () => <div className="d-flex align-items-center">
			<div className="skeleton skeleton2 mr-2" style={{ borderRadius: ".25rem", width: 15, height: 15 }} alt=""/> <div className="skeleton skeleton3" style={{ width: random(40, 80)}} />
		</div>
	}, {
		accessor: 'total_display',
		Header: 'Value',
		Cell: () => <div className="d-flex flex-column">
			<div className="skeleton skeleton1 mb-1 small" style={{ width: random(50, 100)}} />
			<div className="skeleton skeleton3 d-flex small" style={{ width: random(70, 120)}} />
		</div>
	}, {
		accessor: 'status',
		Header: 'Status',
		Cell: () => <div className="skeleton skeleton7" style={{ width: random(40, 80)}} />
	}, {
		accessor: 'created_at',
		Header: 'Time',
		Cell: () => <div className="skeleton skeleton2" style={{ width: random(50, 100)}} />
	}, {
		accessor: 'id',
		Header: '',
		Cell: () => <ArrowRightIcon />
	}];

	if(isMobile) {
		return loading ? <MobilePlaceholder data={[1, 2, 3]} /> : <MobileProducts clearFilters={clearFilters} isAdmin={isAdmin} data={orders} />
	}

	if(loading) {
		return <Table2 data={placeholderData ? placeholderData : [1,2,3,4,5,6,7,8,9,10]} isPlaceholder columns={placeholder} />
	} else if (isEmpty) {
		return <Empty isOrders />
	} else {
		return <Table2
			cursorPointer
			pageSize={10}
			data={ orders }
			clearFilters={clearFilters}
			columns={ columns }
			onClick={(row, e) => {
				if (e.target.tagName !== 'A') {
					if (isAdmin) {
						history.push(`${isAdmin}${row.uniqid}`);
					} else {
						if (e.metaKey || e.ctrlKey) {
							const link = document && document.getElementById(`a-blank-fix-${row.uniqid}`);
							link.click();
							e.preventDefault();
						} else {
							history.push(`/invoices/${row.uniqid}`)
						}
					}
				}
			}}
		/>
	}
}


export default InvoicesTable;

